export class StoreLocalStorage {
    currentVersion = 'v_20250210'; //change if LocalStorage is not compatible

    async isSet() {
        if (localStorage.length > 0) {
            try {
                let version = await localStorage.getItem('version');
                if (version) version = await JSON.parse(version);
                if (version === this.currentVersion) return true;
            } catch (error) {
                localStorage.clear();
            }
        }
    }
    setItem(key: string, value: any): void {
        try {
            const serializedValue = JSON.stringify(value);
            localStorage.setItem(key, serializedValue);
        } catch (error) {
            console.error('Error setting item in localStorage:', error);
        }
    }

    // Get an item from localStorage
    async getItem(key: string, fallback: any, onNotDefined?: () => void): Promise<any> {
        const serializedValue = await localStorage.getItem(key);
        if (serializedValue === null) {
            if (onNotDefined) onNotDefined();
            return fallback;
        }
        return JSON.parse(serializedValue);
    }
}
